import { MainAPiServiceService } from '@_services/main-api-service.service';
import {
  Component,
  inject,
  Input,
  OnInit,
  OnDestroy,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
} from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Subject, takeUntil } from 'rxjs';

@Component({
  selector: 'app-aml-ctf-setting',
  templateUrl: './aml-ctf-setting.component.html',
  styleUrls: ['./aml-ctf-setting.component.scss'],
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AmlCtfSettingComponent implements OnInit, OnDestroy {
  @Input() SettingForm: FormGroup;
  @Input() errorWarningData: any;
  isRequestSent: boolean = false;
  barristername: any;
  isLoading: boolean = false;
  private _mainAPiServiceService = inject(MainAPiServiceService);
  private _unsubscribeAll$: Subject<void> = new Subject();

  constructor(
    private api: MainAPiServiceService,
    private cd: ChangeDetectorRef,
  ) {}

  ngOnInit(): void {
    this.systemName();
  }

  ngOnDestroy(): void {
    this._unsubscribeAll$.next();
    this._unsubscribeAll$.complete();
  }

  get hasAplyIdKey(): boolean {
    return !!this.SettingForm?.get('APLYIDKEY')?.value;
  }

  systemName(): void {
    this._mainAPiServiceService
      .getSetData(
        {
          Action: 'GetData',
          Filters: { GroupName: 'OrganisationalDetails' },
        },
        'system',
      )
      .pipe(takeUntil(this._unsubscribeAll$))
      .subscribe({
        next: (response: any) => {
          if (response.CODE == 200 && response.STATUS == 'success') {
            this.barristername = response.DATA.RECORDS.BARRISTERSNAME;
          }
          this.cd.markForCheck();
        },
        error: (error: any) => {
          this.cd.markForCheck();
        },
      });
  }

  requestAplyIdAccount(): void {
    if (this.isLoading) return;
    this.isLoading = true;
    this.cd.markForCheck();

    const payload = {
      Action: 'createaccount',
      ValidateOnly: false,
      Data: {
        companyName: this.barristername,
      },
    };

    this._mainAPiServiceService
      .getSetData(payload, 'identity-check')
      .pipe(takeUntil(this._unsubscribeAll$))
      .subscribe({
        next: () => {
          this.isRequestSent = true;
          this.isLoading = false;
          this.cd.markForCheck();
        },
        error: () => {
          this.isLoading = false;
          this.cd.markForCheck();
        },
      });
  }
}
